
<div class="col-sm-12">

  <h2> MENU </h2>
<div class="list-group mt-5">
    <a routerLink="/tax-credit" class="list-group-item list-group-item-action flex-column align-items-start list-group-item-dark">
      <div class="d-flex w-100 justify-content-between">
        <h3 class="mb-1">Application For LCSA Tax Credit Determination</h3>
      </div>  
    </a>
   <a routerLink="/armccm" class="list-group-item list-group-item-action flex-column align-items-start list-group-item-dark ">
    <div class="d-flex w-100 justify-content-between">
      <h3 class="mb-1">ARMCCM</h3>
    </div>  
  </a>
    <!--
       Remove the first three forms at the request of the client
           Work Request 152836
       Damage Prevention Complaint Form was re-written. 
           Work Request 150419
    <a routerLink="/efficiency-awards" class="list-group-item list-group-item-action flex-column align-items-start list-group-item-dark">
    <div class="d-flex w-100 justify-content-between">
      <h3 class="mb-1">Economic Leaders in Energy Efficiency Awards</h3>
    </div>  
  </a>
  <a routerLink="/request-information" class="list-group-item list-group-item-action flex-column align-items-start list-group-item-dark">
    <div class="d-flex w-100 justify-content-between">
      <h3 class="mb-1">Hear from Us</h3>
    </div>  
  </a>
  <a routerLink="/energy-planning" class="list-group-item list-group-item-action flex-column align-items-start list-group-item-dark  ">
    <div class="d-flex w-100 justify-content-between">
      <h3 class="mb-1">State Energy Program Planning RFI</h3>
    </div>  
  </a>  
  <a routerLink="/complaint" class="list-group-item list-group-item-action flex-column align-items-start list-group-item-dark">
    <div class="d-flex w-100 justify-content-between">
      <h3 class="mb-1">Damage Prevention Complaint Form</h3>
    </div>  
  </a>
-->

<a routerLink="/leo" class="list-group-item list-group-item-action flex-column align-items-start list-group-item-dark">
  <div class="d-flex w-100 justify-content-between">
    <h3 class="mb-1">Legally Enforceable Obligation (LEO)</h3>
  </div>  
</a>

  <a routerLink="/video-survey/franchise" class="list-group-item list-group-item-action flex-column align-items-start list-group-item-dark">
    <div class="d-flex w-100 justify-content-between">
      <h3 class="mb-1">Video Franchise Survey</h3>
    </div>  
  </a>

  <a routerLink="/video-survey/provider" class="list-group-item list-group-item-action flex-column align-items-start list-group-item-dark">
    <div class="d-flex w-100 justify-content-between">
      <h3 class="mb-1">Video Provider Survey</h3>
    </div>  
  </a>

</div>
</div>